/* Satruven: carrito lateral con la API AJAX de Shopify */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const ICONS = { 'paid-ads-management': 'ph-target', 'seo-package': 'ph-magnifying-glass', 'social-media-marketing': 'ph-instagram-logo', 'content-marketing': 'ph-pen-nib', 'email-marketing': 'ph-envelope-simple', 'web-design-branding': 'ph-palette' };
  const $ = id => document.getElementById(id);
  const drawer = $('cart'); if (!drawer) return;
  let currency = drawer.dataset.currency || 'USD';
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const render = cart => {
    currency = cart.currency || currency;
    document.querySelectorAll('.cart-count').forEach(el => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
    if (!cart.item_count) {
      $('cartBody').innerHTML = `<div class="cart-empty"><i class="ph ph-bag"></i><p>Your cart is empty.</p><a class="btn btn-ghost" href="${root}#plans">See plans</a></div>`;
      $('cartFoot').hidden = true; return;
    }
    $('cartFoot').hidden = false;
    $('cartBody').innerHTML = cart.items.map((it, i) => `
      <div class="cart-item">
        <a class="cart-thumb" href="${it.url}">${it.image ? `<img src="${it.image}&width=144" alt="" width="72" height="72" style="width:100%;height:100%;object-fit:cover;border-radius:16px">` : `<i class="ph ${ICONS[it.handle] || 'ph-sparkle'}"></i>`}</a>
        <div class="cart-info">
          <a href="${it.url}">${esc(it.product_title)}</a>
          <span>${money(it.final_price)}</span>
          <div class="qty qty-sm" data-line="${i + 1}" data-q="${it.quantity}">
            <button type="button" data-d="-1" aria-label="Decrease quantity"><i class="ph ph-minus"></i></button><output>${it.quantity}</output><button type="button" data-d="1" aria-label="Increase quantity"><i class="ph ph-plus"></i></button>
          </div>
        </div>
        <button type="button" class="cart-rm" data-line="${i + 1}">Remove</button>
      </div>`).join('');
    $('cartSub').textContent = money(cart.total_price);
  };

  const req = (url, body) => fetch(root + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } }).then(r => r.json());
  const refresh = () => req('cart.js').then(render);
  const change = (line, quantity) => { drawer.setAttribute('aria-busy', 'true'); return req('cart/change.js', { line, quantity }).then(c => { render(c); drawer.removeAttribute('aria-busy'); }); };

  const open = () => { document.body.classList.add('cart-open'); drawer.setAttribute('aria-hidden', 'false'); };
  const close = () => { document.body.classList.remove('cart-open'); drawer.setAttribute('aria-hidden', 'true'); };

  $('cartBody').addEventListener('click', e => {
    const d = e.target.closest('[data-d]'), rm = e.target.closest('.cart-rm');
    if (d) { const q = d.parentElement; change(+q.dataset.line, Math.max(1, +q.dataset.q + +d.dataset.d)); }
    if (rm) change(+rm.dataset.line, 0);
  });
  $('cartClose').addEventListener('click', close);
  $('cartScrim').addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  document.querySelectorAll('.cart-btn').forEach(b => b.addEventListener('click', e => { e.preventDefault(); open(); }));

  /* formularios de producto: añadir sin salir de la página */
  const add = (form, btn) => {
    btn && btn.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        const err = form.querySelector('.form-error');
        if (!ok) { if (err) { err.textContent = j.description || 'Something went wrong. Please try again.'; err.hidden = false; } return; }
        if (err) err.hidden = true;
        return refresh().then(open);
      })
      .finally(() => btn && btn.removeAttribute('aria-busy'));
  };
  document.querySelectorAll('form[action*="/cart/add"]').forEach(f => f.addEventListener('submit', e => { e.preventDefault(); add(f, f.querySelector('[type=submit]')); }));
  const barAdd = $('barAdd');
  if (barAdd) barAdd.addEventListener('click', () => { const f = document.querySelector('form[action*="/cart/add"]'); if (f) add(f, barAdd); });

  window.SatruvenCart = { open, refresh };
  refresh();
})();
